"use client"

import { Mascot } from "@/components/marketing/landing-v2/Mascot"
import { formatCopy, type Landing2Copy, type Landing2Locale } from "@/lib/landing-v2/copy"
import { PERSIAN_HOME_PATH } from "@/lib/marketing-locale"

export function Landing2Footer({
  copy,
  locale,
  onLocaleChange,
}: {
  copy: Landing2Copy
  locale: Landing2Locale
  onLocaleChange: (locale: Landing2Locale) => void
}) {
  return (
    <footer className="l2-footer">
      <div className="l2-container l2-footer-inner">
        <div className="l2-footer-brand">
          <a className="l2-wordmark" href="#top">
            <Mascot size={26} />
            <span>atirame</span>
          </a>
          <p className="l2-footer-tagline">{copy.footer.tagline}</p>
        </div>

        <div className="l2-footer-meta">
          <nav className="l2-lang" aria-label={copy.nav.language}>
            <button
              type="button"
              onClick={() => onLocaleChange("en")}
              aria-current={locale === "en" ? "true" : undefined}
            >
              EN
            </button>
            <button
              type="button"
              onClick={() => onLocaleChange("hy")}
              aria-current={locale === "hy" ? "true" : undefined}
            >
              HY
            </button>
            <a href={PERSIAN_HOME_PATH} title={copy.nav.persianSite}>
              FA
            </a>
          </nav>
          <span className="l2-footer-copyright">
            {formatCopy(copy.footer.copyright, { year: new Date().getFullYear() })}
          </span>
        </div>
      </div>
    </footer>
  )
}
